// extracted by mini-css-extract-plugin
module.exports = {"inlineErrorContainer":"style_inlineErrorContainer__VAP__","staticAddressContainer":"style_staticAddressContainer__xV17P"};